module.exports = __webpack_public_path__ + "static/media/replique.e939b94a.jpg";